import { useCallback, useEffect, useState } from 'react'
import { INGREDIENTS_TREE_RDB } from '__constants__'
import database from 'services/firebase/database'
import { onValue, ref as databaseRef } from 'firebase/database'

/**
 * Custom hook to fetch and subscribe to the ingredients tree data from Firebase Realtime Database.
 * @returns {Object} The tree data and its loading controls.
 */
const useGetIngredientsTree = () => {
  const [state, setState] = useState({
    data: null,
    error: null,
    loading: true
  })
  const [retryKey, setRetryKey] = useState(0)

  useEffect(() => {
    const ref = databaseRef(database, INGREDIENTS_TREE_RDB)

    const onChange = (snapshot) => {
      setState({ data: snapshot.val() || {}, error: null, loading: false })
    }

    // Subscribe to changes
    const unsubscribe = onValue(ref, onChange, (error) => {
      // eslint-disable-next-line no-console
      console.error('Error fetching ingredients tree data: ', error)
      setState((currentState) => ({
        ...currentState,
        error,
        loading: false
      }))
    })

    // Cleanup function to unsubscribe from changes
    return () => unsubscribe()
  }, [retryKey])

  const retry = useCallback(() => {
    setState((currentState) => ({
      ...currentState,
      error: null,
      loading: true
    }))
    setRetryKey((currentKey) => currentKey + 1)
  }, [])

  return { ...state, retry }
}

export default useGetIngredientsTree
